module.exports = __webpack_public_path__ + "static/logos-11-2888ae148dd6d3b4b974d244c078e1b6.png";